<template>
  <main>
    <UtilRendererContent
      v-if="content"
      :data="content"
    />
  </main>
</template>

<script setup>
definePageMeta({
    layout: 'loggedin',
    middleware: [
        'page-permission',
        'auth-auth',
    ],
});

const { content, seo } = getPageContent();
useHead({
    title: seo?.title || '',
});
</script>
